import types from '../../../mutation-types';

export const setPageFilter = ({ dispatch, filter, page, markEndReached }) => {
  dispatch('conversationPage/setCurrentPage', { filter, page }, { root: true });
  if (markEndReached) {
    dispatch('conversationPage/setEndReached', { filter }, { root: true });
  }
};

export const setContacts = (commit, chatList) => {
  commit(
    `contacts/${types.SET_CONTACTS}`,
    chatList.map(chat => chat.meta.sender)
  );
};

export const isOnMentionsView = ({ route: { name: routeName } }) => {
  const MENTION_ROUTES = [
    'conversation_mentions',
    'conversation_through_mentions',
  ];
  return MENTION_ROUTES.includes(routeName);
};

export const isOnUnattendedView = ({ route: { name: routeName } }) => {
  const UNATTENDED_ROUTES = [
    'conversation_unattended',
    'conversation_through_unattended',
  ];
  return UNATTENDED_ROUTES.includes(routeName);
};

export const isOnUnreadView = ({ route: { name: routeName } }) => {
  const UNREAD_ROUTES = [
    'conversation_unread',
    'conversation_through_unread',
  ];
  return UNREAD_ROUTES.includes(routeName);
};

export const isLastMessageClientView = ({ route: { name: routeName } }) => {
  const LAST_MESSAGE_CLIENT = [
    'conversation_last_message_client'
  ];
  return LAST_MESSAGE_CLIENT.includes(routeName);
};

export const buildConversationList = (
  context,
  requestPayload,
  responseData,
  filterType
) => {
  const { payload: conversationList, meta: metaData } = responseData;
  context.commit(types.SET_ALL_CONVERSATION, { conversationList, forceReset: !!requestPayload.reset });
  context.dispatch('conversationStats/set', metaData);
  context.dispatch(
    'conversationLabels/setBulkConversationLabels',
    conversationList
  );
  context.dispatch(
    'conversationProductLabels/setBulkConversationProductLabels',
    conversationList
  );
  context.dispatch(
    'conversationTopicLabels/setBulkConversationTopicLabels',
    conversationList
  );
  context.dispatch(
    'conversationConcurrentLabels/setBulkConversationConcurrentLabels',
    conversationList
  );
  context.commit(types.CLEAR_LIST_LOADING_STATUS);
  setContacts(context.commit, conversationList);
  setPageFilter({
    dispatch: context.dispatch,
    filter: filterType,
    page: requestPayload.page,
    markEndReached: !conversationList.length,
  });
};
